import { FC, useState } from 'react';
import { useAppSelector } from 'app/store';
import {
  getReleaseVersion,
  getVersionSyncStatus,
} from 'app/store/Releases/selectors';
import { useResource } from 'app/utils/hooks';
import { fetchSongDDLEffect } from 'app/store/SongList/effects';
import { getSongDDLSelector } from 'app/store/SongList/selectors';
import { ReleaseType, ReleaseVersionAudioData } from 'types/releases';
import {
  useFetchAudioDependencies,
  useFetchPrimaryAudio,
  useReplaceAudioVersion,
  useUpdateAudioDetails,
  useUpdateVersion,
  useValidations,
} from '../hooks';
import { SoundCloudVersionDetailsFormComponent } from './SoundCloudVersionDetailsFormComponent';
import { SoundCloudVersionFormLoader } from '../SoundCloudVersionFormLoader';
import { getPreferredAudioSelectionOption } from './utils';

export const SoundCloudVersionDetailsForm: FC = () => {
  const releaseVersion = useAppSelector(getReleaseVersion);
  const isSyncing =
    useAppSelector((state) =>
      getVersionSyncStatus(state, releaseVersion?.song.versionGuid || '')
    ) || false;

  const [audioData, setAudioData] = useState<ReleaseVersionAudioData>({
    items: [],
  });
  const [songDDL, songDDLLoading] = useResource(
    fetchSongDDLEffect,
    getSongDDLSelector
  );
  const { audioDataLoading } = useFetchAudioDependencies(setAudioData);

  const {
    primaryAudioFetching,
    setPrimaryAudioFetching,
    primaryAudio,
    setPrimaryAudio,
  } = useFetchPrimaryAudio();

  const { updateAudioDetails } = useUpdateAudioDetails(
    setPrimaryAudio,
    primaryAudio
  );
  const { replaceAudioVersion, isAudioReplacing } = useReplaceAudioVersion(
    setPrimaryAudioFetching
  );
  const {
    validationsLoading,
    versionValidations,
    versionSongValidations,
    updateVersionAudioValidations,
    fetchAudioDetailsValidations,
  } = useValidations();

  const { updateVersion } = useUpdateVersion(ReleaseType.SOUNDCLOUD);

  if (
    audioDataLoading ||
    validationsLoading ||
    songDDLLoading ||
    isSyncing ||
    (!releaseVersion && primaryAudioFetching)
  ) {
    return <SoundCloudVersionFormLoader />;
  }

  return releaseVersion && versionValidations && versionSongValidations ? (
    <SoundCloudVersionDetailsFormComponent
      genresDDL={songDDL?.genres || {}}
      releaseVersion={releaseVersion}
      replaceAudioVersion={replaceAudioVersion}
      versionValidations={versionValidations}
      audioData={audioData}
      updateVersion={updateVersion}
      isAudioReplacing={isAudioReplacing}
      fetchAudioDetailsValidations={fetchAudioDetailsValidations}
      updateAudioValidations={updateVersionAudioValidations}
      updateAudioDetails={updateAudioDetails}
      primaryAudio={getPreferredAudioSelectionOption(primaryAudio)}
      primaryAudioFetching={primaryAudioFetching}
      isSyncing={isSyncing}
    />
  ) : null;
};
